import { ChangeDetectionStrategy, Component, computed, inject, OnInit, output } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { ViewSubmissionStore } from '@program-suite/data-common';
import { ButtonComponent } from '@program-suite/ui';
import { AuthStore } from '@program-suite/data-auth';

@Component({
  selector: 'lib-pricing',
  imports: [CommonModule, CurrencyPipe],
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss', '../view-submission.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricingComponent implements OnInit {
  viewSubmissionStore = inject(ViewSubmissionStore);
  authStore = inject(AuthStore);
  changeTabEvent = output<string>();
  id: string | null = null;
  isPolicyPage: boolean = false;
  quoteBreakdown = computed(() => this.viewSubmissionStore?.quoteBreakdown?.());
  isBreakdownVisible = false;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.isPolicyPage = this.route.snapshot.url[0].path =='policies';
    this.viewSubmissionStore?.getSubmissionPricingTotals(this.id ?? '', this.isPolicyPage);
    if (this.authStore.isWholesale() || this.authStore.isAdmin()) {
      this.viewSubmissionStore?.getSubmissionPremiumBreakdown(this.id ?? '', this.isPolicyPage);
    }
  }

  toggleBreakdown() {
    this.isBreakdownVisible = !this.isBreakdownVisible;
  }
}
